import {
  categories_tab,
  menus_tab,
  modifier_groups_tab,
  modifiers_tab,
  products_tab,
} from '../../../../../../views/menu/smart-pricing';
import { SMART_PRICING_RESOURCE_TYPE } from '../../../../../../services/exports/Constants';

export default {
  title: 'Smart prissætning',
  master_title: 'Brandtilstand - Smart prissætning',
  sections: {
    how_it_works: {
      title: 'Sådan fungerer det',
      description:
        'Smart prissætning er en funktion, der giver dig mulighed for at styre dine priser ud fra den bestillingsmetode, kunden bruger. Det dækker flere anvendelser, f.eks. lavere pris ved afhentning, højere pris ved levering, rabat på sæsonmenuer osv. Du kan oprette regler på flere niveauer (Global, Menu, Kategori, Produkt, Tilvalgsgruppe, Tilvalg). Niveauerne fungerer som et træ, hvor et højere niveau påvirker de lavere niveauer. Samtidig har en regel på et lavere niveau højere prioritet end en regel på et højere niveau (f.eks. vil en afhentningsrabat på 5 % på en bestemt kategori overskrive den globale afhentningsrabat på 15 % for kategoriens produkter).',
    },
  },
  tabs: {
    [SMART_PRICING_RESOURCE_TYPE.company]: 'Globale regler',
    [SMART_PRICING_RESOURCE_TYPE.franchise]: 'Globale regler',
    [menus_tab]: 'Menuregler',
    [categories_tab]: 'Kategoriregler',
    [products_tab]: 'Produktregler',
    [modifier_groups_tab]: 'Regler for tilvalgsgrupper',
    [modifiers_tab]: 'Tilvalgsregler',
  },
  fields: {
    name: 'Navn',
    order_methods: 'Bestillingsmetoder',
    modifier: 'Tilvalg',
    image: 'Billede',
    actions: 'Handlinger',
  },
  labels: {
    absolute: 'Absolut',
  },
  buttons: {
    add_rule: 'Tilføj regel',
    edit: 'Rediger',
    delete: 'Slet ({{count}})',
    images: 'Administrer billede',
  },
  popups: {
    delete_rule: {
      title: 'Er du sikker på, at du vil slette?',
    },
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
    failed_to_delete: 'Reglerne kunne ikke slettes',
    deleted_successfully: 'Reglerne blev slettet',
  },
};
